import React from 'react';
import { Phone, MessageCircle, Navigation } from 'lucide-react';

const MobileStickyBar = ({ language }) => {
  const content = {
    de: {
      call: "Anrufen",
      whatsapp: "WhatsApp",
      navigation: "Route"
    },
    en: {
      call: "Call",
      whatsapp: "WhatsApp",
      navigation: "Route"
    }
  };

  const handleCall = () => {
    window.location.href = 'tel:+491726060056';
  };

  const handleWhatsApp = () => {
    window.open('https://wa.me/491726060056', '_blank');
  };

  const handleNavigation = () => {
    const address = "Hellweg 15, 44787 Bochum, Germany";
    const encodedAddress = encodeURIComponent(address);
    
    // Detect device and open appropriate maps app
    const isIOS = /iPad|iPhone|iPod/?.test(navigator?.userAgent);
    
    if (isIOS) {
      window.open(`https://maps.apple.com/?q=${encodedAddress}`, '_blank');
    } else {
      window.open(`https://www.google.com/maps/search/?api=1&query=${encodedAddress}`, '_blank');
    }
  };

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-primary/95 backdrop-blur-sm border-t border-secondary/20 p-4 md:hidden z-50">
      <div className="grid grid-cols-3 gap-4 max-w-sm mx-auto">
        <button
          onClick={handleCall}
          className="flex flex-col items-center justify-center p-3 bg-secondary text-primary rounded-lg shadow-luxury hover:bg-secondary/90 transition-luxury"
        >
          <Phone size={20} />
          <span className="text-xs font-body font-medium mt-1">
            {content?.[language]?.call}
          </span>
        </button>
        
        <button
          onClick={handleWhatsApp}
          className="flex flex-col items-center justify-center p-3 border border-secondary text-secondary rounded-lg hover:bg-secondary hover:text-primary transition-luxury"
        >
          <MessageCircle size={20} />
          <span className="text-xs font-body font-medium mt-1">
            {content?.[language]?.whatsapp}
          </span>
        </button>
        
        <button
          onClick={handleNavigation}
          className="flex flex-col items-center justify-center p-3 border border-secondary text-secondary rounded-lg hover:bg-secondary hover:text-primary transition-luxury"
        >
          <Navigation size={20} />
          <span className="text-xs font-body font-medium mt-1">
            {content?.[language]?.navigation}
          </span>
        </button>
      </div>
    </div>
  );
};

export default MobileStickyBar;